import { TagsList, TagsListItem } from '@/components/core'
import { BrandTerms, DataSourceType } from '../../types'
import {
  FieldTitle,
  NoTermsText,
  RulesPreviewContent,
  SectionTitle,
  TermsPreviewGrid,
  TermsPreviewItem,
  TermsPreviewSection,
} from './CompoundTermsPreview.styles'

interface CompoundTermsPreviewProps {
  polarity: 'POSITIVO_FAVORAVEL' | 'NEGATIVO_DESFAVORAVEL'
  termsState: BrandTerms
  activeTab: DataSourceType
}

export function CompoundTermsPreview({ polarity, termsState, activeTab }: CompoundTermsPreviewProps): JSX.Element {
  const isActiveTabSocial = activeTab === 'social'

  const getCompoundTerms = () => {
    if (isActiveTabSocial) {
      const publishersTags =
        polarity === 'POSITIVO_FAVORAVEL' ?
          termsState.socialPositiveFavorablePublishersTags
        : termsState.socialNegativeUnfavorablePublishersTags

      const proprietaryTags =
        polarity === 'POSITIVO_FAVORAVEL' ?
          termsState.socialPositiveFavorableProprietaryTags
        : termsState.socialNegativeUnfavorableProprietaryTags

      return { publishersTags, proprietaryTags, channelsTags: [] }
    } else {
      const channelsTags =
        polarity === 'POSITIVO_FAVORAVEL' ?
          termsState.pressPositiveFavorableChannelsTags
        : termsState.pressNegativeUnfavorableChannelsTags

      const proprietaryTags =
        polarity === 'POSITIVO_FAVORAVEL' ?
          termsState.pressPositiveFavorableProprietaryTags
        : termsState.pressNegativeUnfavorableProprietaryTags

      return { channelsTags, proprietaryTags, publishersTags: [] }
    }
  }

  const { publishersTags, channelsTags, proprietaryTags } = getCompoundTerms()

  return (
    <RulesPreviewContent>
      <TermsPreviewSection>
        <SectionTitle>Termos - {isActiveTabSocial ? 'Redes Sociais' : 'Imprensa'}</SectionTitle>
        <TermsPreviewGrid>
          <TermsPreviewItem>
            <FieldTitle>{isActiveTabSocial ? 'Publicadores:' : 'Veículos:'}</FieldTitle>
            {(isActiveTabSocial ? publishersTags : channelsTags).length > 0 ?
              <TagsList
                maxVisible={10}
                tags={(isActiveTabSocial ? publishersTags : channelsTags).map(
                  (tag) =>
                    ({
                      id: tag.id,
                      text: tag.text,
                    }) as TagsListItem,
                )}
                variant="preview"
                emptyText="Nenhum definido"
              />
            : <NoTermsText>Nenhum definido</NoTermsText>}
          </TermsPreviewItem>

          <TermsPreviewItem>
            <FieldTitle>Termos Proprietários:</FieldTitle>
            {proprietaryTags.length > 0 ?
              <TagsList
                maxVisible={10}
                tags={proprietaryTags.map(
                  (tag) =>
                    ({
                      id: tag.id,
                      text: tag.text,
                    }) as TagsListItem,
                )}
                variant="preview"
                emptyText="Nenhum definido"
              />
            : <NoTermsText>Nenhum definido</NoTermsText>}
          </TermsPreviewItem>
        </TermsPreviewGrid>
      </TermsPreviewSection>
    </RulesPreviewContent>
  )
}
